export default class IndustryTrendService {
  getAll(otype) {
    return fetch("https://api.tradersr.com/api/industrytrend?otype=" + otype)
      .then(res => res.json());
  }
}